export const SYSTEMPermission = {
    'ACCOUNT_VIEW': '100_002_001', // 系统配置-账号管理-查看
    'ACCOUNT_ADD': '100_002_002', // 系统配置-账号管理-新增
    'ACCOUNT_EDIT': '100_002_003', // 系统配置-账号管理-编辑
    'ACCOUNT_DEL': '100_002_004', // 系统配置-账号管理-删除
    'ROLE_VIEW': '100_001_001', // 系统配置-角色管理-查看
    'ROLE_ADD': '100_001_002', // 系统配置-角色管理-新增
    'ROLE_EDIT': '100_001_003', // 系统配置-角色管理-编辑
    'ROLE_DEL': '100_001_004', // 系统配置-角色管理-删除
    'ACTIVE_MANAGEMENT': '101_001_001', // 首页-活动管理
    'CLIENT_MANAGEMENT': '101_001_002', // 首页-客户管理
    'MY_PRODUCT': '101_001_003', // 首页-我的产品
    'ONLINE_POLICY': '101_001_004', // 首页-线上保单
    'ORGREPORTM': '101_001_005', // 首页-机构人员业务统计
    'SEE_PROMOTION': '201_001_002', //查看推广费
    'APPOINTMENT_POLICY': '301_001_001', //预约投保单权限
};
